'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (defaultWeb3Provider) {
  return function () {
    if (!defaultWeb3Provider) {
      throw new Error('No web3 provider detected');
    }
    return defaultWeb3Provider;
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/services/walletProviders/browserProvider.js
// module id = 1234
// module chunks = 0